import { ConservationBenchmarkType, Fact } from '@/api/rest/resources/conservation';
import { PlotReportFactElement } from '@/api/rest/resources/types/fact';
import { GraphFact } from '@/components/Charts/types';
import { isNullish } from '@/utils/booleans';

export const getBenchmarkForConservationFact = ({
  fact,
  benchmarks,
}: {
  fact: Fact | PlotReportFactElement<GraphFact[] | null> | { value: number | null } | undefined;
  benchmarks: Record<ConservationBenchmarkType, number | undefined> | undefined;
}) => {
  if (isNullish(fact) || isNullish(fact.value) || isNullish(benchmarks)) {
    return null;
  }

  const factValue = Number(fact.value);

  if (benchmarks.thriving && factValue >= benchmarks.thriving) {
    return ConservationBenchmarkType.thriving;
  }

  if (benchmarks.healthy && factValue >= benchmarks.healthy) {
    return ConservationBenchmarkType.healthy;
  }

  if (benchmarks.managing && factValue >= benchmarks.managing) {
    return ConservationBenchmarkType.managing;
  }

  if (benchmarks.fragile && factValue >= benchmarks.fragile) {
    return ConservationBenchmarkType.fragile;
  }

  return ConservationBenchmarkType.degraded;
};
